import type { AccessChecker, NavNode, PathBuilder, Translate } from './types';

import { NewspaperIcon } from '@valwin/facto/icons';

import { ROUTES } from '~shared/routes';

export function buildNewsItem(
  buildPath: PathBuilder,
  t: Translate,
  checkAccess: AccessChecker
): NavNode {
  const hasBlog = checkAccess({ isAdmin: true, requiredFeatures: ['BLOG'] });

  if (hasBlog) {
    return {
      kind: 'group',
      id: 'news',
      label: t('menu news'),
      icon: NewspaperIcon,
      children: [
        {
          kind: 'link',
          id: 'blog',
          label: t('menu blog'),
          to: buildPath(ROUTES.blog.root),
        },
        {
          kind: 'link',
          id: 'valwin-news',
          label: t('menu suggestedArticles'),
          to: buildPath(ROUTES.valwinNews),
        },
      ],
    };
  }

  return {
    kind: 'link',
    id: 'valwin-news',
    label: t('menu suggestedArticles'),
    icon: NewspaperIcon,
    to: buildPath(ROUTES.valwinNews),
  };
}
